import { Button, Col, Grid, Row } from "react-bootstrap";

import Card from "../Card/Card";
import { FormattedMessage, injectIntl } from "react-intl";
import MainContentHeader from "../Header/MainContentHeader";
// import PropTypes from "prop-types";
import Queries from "../../queries/queries2";
import React from "react";
import Spinner from "../../elements/Spinner/Spinner";
import TaxList from "./TaxList";
import TaxSideModalForm from "./TaxSideModalForm";
import { compose } from "recompose";
import { graphql } from "react-apollo/index";
import { withRouter } from "react-router-dom";

import SuperpositionHeader from "../../components/Header/SuperpositionHeader";
import SettingsTypeSelect from "../settings/settingsTypeSelect";

const defaultTaxValue = {
  label: "",
  pourcentValue: 0,
  isActive: true,
  defaultTaxCheck: false,
  mode: "ENCAISSEMENT"
};

class TaxContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sideModalVisible: false,
      taxeValue: defaultTaxValue,
      tax1: { id: "" },
      tax2: { id: "" },
      editMode: false
    };
  }

  createTax = async (
    label,
    valuePourcent,
    isActive,
    id,
    defaultTaxCheck,
    mode,
    // codeDeclarationVente,
    // codeDeclarationAchat,
    // codeDeclarationImmo
  ) => {
    let values = {};
    let defaultvalues = {};
    defaultvalues["companyId"] = this.props.companyId;
    defaultvalues["tax1Id"] = "";
    defaultvalues["connectTax1"] = false;
    defaultvalues["disconnectTax1"] = false;

    defaultvalues["tax2Id"] = "";
    defaultvalues["connectTax2"] = false;
    defaultvalues["disconnectTax2"] = false;

    values["taxId"] = id;
    values["companyId"] = this.props.companyId;
    values["label"] = label;
    values["active"] = isActive;
    values["valuePourcent"] = valuePourcent;
    values["mode"] = mode;

    // const tmp = {
    //   codeDeclarationVente: codeDeclarationVente || "",   // DEFAULT VALUES ?
    //   codeDeclarationAchat: codeDeclarationAchat || "",
    //   codeDeclarationImmo: codeDeclarationImmo || ""
    // }
    // values["xtraData"] = JSON.stringify(tmp, null, 2);

    let tax1 = this.props.taxes.company && this.props.taxes.company.tax1;
    let tax2 = this.props.taxes.company && this.props.taxes.company.tax2;

    if (this.state.editMode === false) {
      const res = await this.props.createTaxMutation({
        variables: values
      });
      console.log("createTaxMutation res", res);
      const taxLen = res.data.updateCompany.taxes.length;
      id = res.data.updateCompany.taxes[taxLen - 1].id;
    } else {
      const res = await this.props.updateTaxMutation({
        variables: values
      });
      console.log("createTaxMutation res", res);
    }

    if (defaultTaxCheck === false || !isActive) {
      if (tax1 && id === tax1.id) {
        console.log("unlink from tax1 default");
        defaultvalues["tax1Id"] = id;
        defaultvalues["disconnectTax1"] = true;
      } else if (tax2 && id === tax2.id) {
        console.log("unlink from tax2 default");
        defaultvalues["tax2Id"] = id;
        defaultvalues["disconnectTax2"] = true;
      }
    } else {
      if (tax1 && label.toLowerCase() === tax1.label.toLowerCase()) {
        defaultvalues["tax1Id"] = id;
        defaultvalues["connectTax1"] = true;
      } else if (tax2 && label.toLowerCase() === tax2.label.toLowerCase()) {
        defaultvalues["tax2Id"] = id;
        defaultvalues["connectTax2"] = true;
      } else if (!tax1) {
        defaultvalues["tax1Id"] = id;
        defaultvalues["connectTax1"] = true;
      } else if (!tax2) {
        defaultvalues["tax2Id"] = id;
        defaultvalues["connectTax2"] = true;
      } else {
        alert("Pas plus de 2 tax par default.\nDécocher une taxe par default");
      }
    }

    const defaultRes = await this.props.updateDefaultTaxesMutation({
      variables: defaultvalues,
      refetchQueries: [
        {
          options: {
            fetchPolicy: "network-only"
          },
          query: Queries.GET_ALL_COMPANY_TAXES,
          variables: { companyId: this.props.companyId }
        }
      ]
    });
    console.log("defaultRes", defaultRes);
    // console.log("state", this.state);
    // if (defaultvalues["disconnectTax1"]) await this.setState({ tax1: null });
    // console.log("state", this.state);

    this.setSideModalVisible(false);
  };

  setSideModalVisible(value, taxeValue, editMode, company) {
    console.log("setSideModalVisible", company, taxeValue);
    var checked = false;
    let taxeInfo = defaultTaxValue;
    if (taxeValue) {
      console.log(
        "taxeValueID : ",
        taxeValue.id,
        "\nthis.TAX1",
        company && company.tax1,
        "\nthis.TAX2",
        company && company.tax2
      );
      if (
        taxeValue.id === (company && company.tax1 && company.tax1.id) ||
        taxeValue.id === (company && company.tax2 && company.tax2.id)
      )
        checked = true;
      taxeInfo = {
        id: taxeValue.id,
        label: taxeValue.label,
        pourcentValue: taxeValue.valuePourcent,
        isActive: taxeValue.isActive,
        defaultTaxCheck: checked,
        mode: taxeValue.mode,
        // codeDeclarationVente: taxeValue.codeDeclarationVente,
        // codeDeclarationAchat: taxeValue.codeDeclarationAchat,
        // codeDeclarationImmo: taxeValue.codeDeclarationImmo
      };
    }
    this.setState({
      sideModalVisible: value,
      taxeValue: taxeInfo,
      editMode: editMode
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const query_taxes = nextProps.taxes;

    // console.log("164 - getDerivedStateFromProps", query_taxes);
    let res = { ...prevState };

    if (query_taxes && query_taxes.company && query_taxes.company.taxes) {
      if (!!nextProps.taxes.company.tax1) {
        res.tax1 = nextProps.taxes.company.tax1;
      }
      if (!!nextProps.taxes.company.tax2) {
        res.tax2 = nextProps.taxes.company.tax2;
      }
    }
    return res;
  }

  render() {
    if (!this.props.taxes || this.props.taxes.loading) {
      return <Spinner size="lg" fullScreen />;
    }

    // console.log("186 - this.props=", this.props);

    const query_taxes = this.props.taxes;
    let defaultTaxId = null;
    // const state = this.state;

    let data;
    let modalOptions = [];
    if (this.props.taxes) {
      console.log("query_taxes.company", query_taxes.company);

      // builds data array

      if (query_taxes && query_taxes.company && query_taxes.company.taxes) {
        data = query_taxes.company.taxes.map(tax => {
          // look up this tax in company taxes
          const checked =
            tax.id ===
            (query_taxes.company.tax1 && query_taxes.company.tax1.id) ||
            tax.id ===
            (query_taxes.company.tax2 && query_taxes.company.tax2.id) ||
            false;
          console.log(
            "check",
            tax.id,
            query_taxes.company.tax1 && query_taxes.company.tax1.id,
            query_taxes.company.tax2 && query_taxes.company.tax2.id,
            checked
          );

          if (checked) {
            defaultTaxId = query_taxes.company.tax1 && query_taxes.company.tax1.id;
          }

          // let codeDeclarationVente = "";  // DEFAULT VALUES ?
          // let codeDeclarationAchat = "";  // DEFAULT VALUES ?
          // let codeDeclarationImmo = "";   // DEFAULT VALUES ?

          // if (tax.xtraData) {
          //   const tmp = JSON.parse(tax.xtraData);
          //   if (tmp) {
          //     codeDeclarationVente = tmp.codeDeclarationVente;
          //     codeDeclarationAchat = tmp.codeDeclarationAchat;
          //     codeDeclarationImmo = tmp.codeDeclarationImmo;
          //   }
          // }

          return {
            id: tax.id,
            label: tax.label,
            valuePourcent: tax.valuePourcent,
            isActive: tax.active,
            defaultChecked: checked,
            mode: tax.mode,
            // codeDeclarationVente: codeDeclarationVente,
            // codeDeclarationAchat: codeDeclarationAchat,
            // codeDeclarationImmo: codeDeclarationImmo
          };
        });
      }

      // builds options array

      query_taxes.company &&
        query_taxes.company.taxes &&
        query_taxes.company.taxes.map(tax => {
          return modalOptions.push({
            label: `${tax.label}: ${tax.valuePourcent}%`,
            value: tax.id,
            element: tax
          });
        });
    }

    console.log("this.state.taxeValue", this.state.taxeValue);

    let disableDefaultTax = false;
    if (this.state.taxeValue && this.state.taxeValue.id && this.state.taxeValue.id !== defaultTaxId && defaultTaxId) {
      disableDefaultTax = true;
    }

    return (
      <div>
        <FormattedMessage id={"ids_settings"}>
          {backBtnText => (
            <SuperpositionHeader
              backBtnText={backBtnText}
              transparent={true}
              handleMinimizeSidebar={this.props.handleMinimizeSidebar}
            >
              <div>
                <Button
                  bsStyle="primary"
                  className="btn-fill pull-right"
                  onClick={() => {
                    console.log("onclick");
                    this.setSideModalVisible(
                      true,
                      this.state.taxeValue,
                      false,
                      query_taxes.company
                    );
                  }}>
                  <i className="fa fa-lg fa-plus-circle margin-right-5" />
                  <FormattedMessage id="ids_new" />
                </Button>
              </div>
            </SuperpositionHeader>
          )}
        </FormattedMessage>
        <Grid fluid>
          {/* <MainContentHeader name={"Taxes"} hasBtn={true}>
            <Button
              // icon
              // wd
              bsStyle="primary"
              className="btn-fill pull-right"
              onClick={() => {
                console.log("onclick");
                this.setSideModalVisible(
                  true,
                  this.state.taxeValue,
                  false,
                  query_taxes.company
                );
              }}>
              <i className="fa fa-lg fa-plus-circle" />
              <FormattedMessage id="ids_add" />
            </Button>
          </MainContentHeader> */}
          {this.state.sideModalVisible === true ? (
            <FormattedMessage id="ids_registerNewTax">
              {title => (
                <TaxSideModalForm
                  title={title}
                  options={modalOptions}
                  tax={this.state.taxeValue}
                  sideModalVisible={true}
                  disableDefaultTax={disableDefaultTax}
                  defaultTaxCheck={false}
                  setSideModalVisible={bool => {
                    this.setSideModalVisible(
                      bool,
                      "",
                      undefined,
                      query_taxes.company
                    );
                  }}
                  onSubmit={this.createTax}
                />
              )}
            </FormattedMessage>
          ) : (
            <span />
          )}


          <div className="main-content" style={{ marginTop: "32px" }}>
            <Row>
              <div>
                <Col xs={12} sm={5} lg={5} mdOffset={3}>
                  <SettingsTypeSelect
                    value={"TAXES"}
                    companyId={this.props.companyId}
                    intl={this.props.intl}
                    history={this.props.history}
                    role={this.props.role}
                    path={this.props.path}
                  >
                  </SettingsTypeSelect>
                </Col>
              </div>
            </Row>

            <div className="margin-top-40">
              <Row>
                <Col md={12}>
                  <Card>
                    <TaxList
                      data={data}
                      handleRowClick={(value, taxeValue) => {
                        this.setSideModalVisible(
                          !this.state.sideModalVisible,
                          taxeValue,
                          true,
                          query_taxes.company
                        );
                      }}
                    />
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
        </Grid>
      </div>
    );
  }
}

export default compose(
  graphql(Queries.GET_ALL_COMPANY_TAXES, {
    name: "taxes"
  }),
  graphql(Queries.createCompanyTax, {
    name: "createTaxMutation",
    options: { fetchPolicy: "no-cache" }
  }),
  graphql(Queries.updateCompanyTax, {
    name: "updateTaxMutation",
    options: { fetchPolicy: "no-cache" }
  }),
  graphql(Queries.updateCompanyDefaultTaxes, {
    name: "updateDefaultTaxesMutation"
  })
)(injectIntl(withRouter(TaxContainer)));
